
export const EVENT_LOCATION = Object.freeze({
    ONLINE : 1,
    IN_PERSON : 2,
    ALL : 3,
})
export const EVENT_LOCATION_IN_PERSON = Object.freeze({
    TRADITIONAL_INPUT : 1,
    FROM_SUGGESTION : 2,
})


export const EVENT_SEARCH_LOCATION = Object.freeze({
    ONLINE : 2,
    IN_PERSON : 3,
    ALL : 1,
})

export const EVENT_TICKETS = Object.freeze({
    PAID : 1,
    FREE : 2
})

export const EVENTS_LIST = Object.freeze({
    FAVOURITES : "favourites",
    FEATURED : "featured",
    POPULAR : 'popular',
    NEARBY : 'nearby',
    EVENT_TYPE : 'event-type',
    UPCOMING:'upcoming',
    COMNETE:'comnete',
    NEWEST:"newest"


})
